
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"13","viewBox":"0 0 16 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5 1.51813C14.9363 1.7627 14.3401 1.92437 13.73 1.99813C14.3736 1.61362 14.856 1.00871 15.0875 0.295626C14.4827 0.655673 13.8206 0.909349 13.13 1.04563C12.6684 0.545055 12.0537 0.211848 11.3824 0.0982646C10.711 -0.0153191 10.0209 0.0971448 9.42034 0.418018C8.81978 0.738891 8.3427 1.25002 8.06393 1.87125C7.78516 2.49248 7.72047 3.18867 7.88 3.85063C6.65707 3.78877 5.46083 3.47034 4.36899 2.91602C3.27715 2.3617 2.31413 1.5839 1.5425 0.633126C1.27185 1.10575 1.12964 1.64099 1.13 2.18563C1.12904 2.69141 1.25316 3.18959 1.49132 3.6358C1.72947 4.08201 2.07426 4.46241 2.495 4.74313C2.00598 4.72982 1.52741 4.5986 1.1 4.36063V4.39813C1.10367 5.10679 1.352 5.79245 1.80299 6.3391C2.25398 6.88575 2.87994 7.25986 3.575 7.39813C3.30744 7.47955 3.02966 7.52248 2.75 7.52563C2.55642 7.52336 2.36332 7.50581 2.1725 7.47313C2.37043 8.08274 2.75347 8.61549 3.26831 8.99725C3.78315 9.37901 4.40418 9.59079 5.045 9.60313C3.9629 10.4546 2.62691 10.9193 1.25 10.9231C0.999301 10.9239 0.748802 10.9089 0.5 10.8781C1.90582 11.7858 3.54411 12.2677 5.2175 12.2656C6.37227 12.2776 7.51785 12.0594 8.58734 11.6237C9.65682 11.188 10.6288 10.5435 11.4464 9.728C12.264 8.91246 12.911 7.94217 13.3494 6.87381C13.7879 5.80544 14.009 4.66042 14 3.50563C14 3.37813 14 3.24313 14 3.10813C14.5885 2.66923 15.0961 2.13119 15.5 1.51813Z","fill":"#444444"}})])
          )
        }
      }
    